module.exports = __webpack_public_path__ + "img/university_4.f78afe54.png";